'use client';

import { useEffect, useState } from 'react';

/**
 * Track the visual-viewport height so a bottom-sheet stays above the on-screen
 * keyboard (a focused search input shrinks `visualViewport.height`). Caps the
 * sheet at 85% of the visible viewport; falls back to 85dvh where
 * `visualViewport` is unavailable. Shared by every Vaul drawer (popover + pane).
 */
export const useDrawerMaxHeight = () => {
	const [visualHeight, setVisualHeight] = useState<number | undefined>(undefined);

	useEffect(() => {
		const vv = window.visualViewport;
		if (!vv) return;
		const sync = () => setVisualHeight(vv.height);
		sync();
		vv.addEventListener('resize', sync);
		return () => vv.removeEventListener('resize', sync);
	}, []);

	return visualHeight ? `${visualHeight * 0.85}px` : '85dvh';
};
